import { basicLogger, initialize } from 'launchdarkly-js-client-sdk';

import { createLaunchDarklyFeatureFlagService } from './launch-darkly';

import type { FeatureFlagService } from './feature-flag-service';
import type { LaunchDarklyFeatureFlagServiceOptions } from './launch-darkly';

type FeatureFlagServiceOptions = Pick<LaunchDarklyFeatureFlagServiceOptions, 'tenantId'> & {
    readonly launchDarklyBaseUrl: LaunchDarklyFeatureFlagServiceOptions['baseUrl'];
    readonly launchDarklyEventsUrl: LaunchDarklyFeatureFlagServiceOptions['eventsUrl'];
};

export const createFeatureFlagService = (options: FeatureFlagServiceOptions): FeatureFlagService => {
    const { launchDarklyBaseUrl, launchDarklyEventsUrl, tenantId } = options;

    return createLaunchDarklyFeatureFlagService(
        {
            initializeLaunchDarkly: initialize,
            launchDarklyLogger: basicLogger({ level: 'none' }),
        },
        {
            baseUrl: launchDarklyBaseUrl,
            eventsUrl: launchDarklyEventsUrl,
            tenantId,
        },
    );
};
